module.exports = __webpack_public_path__ + "media/public/img/twitter-round-01-cd1e625a8cae957d25deef6d92bf4839.svg";